




















































































import { Component, Vue } from 'vue-property-decorator';
import { CallsApi } from '../api/calls';
import AppMessage from 'modules/core/models/appMessage';
import { ElTable } from 'element-ui/types/table';
import { CallVm } from '../classes/callVm';
import { CallHistoryVm } from '../classes/callHistoryVm';
import moment, { Moment } from 'moment';
import PureVueChart from 'modules/common/components/PureVueChart.vue';

@Component({
  components: {
    PureVueChart,
  },
})
export default class List extends Vue {
  public callHistoryColumns: any[] = [];
  public callHistoryData: CallHistoryVm = {
    calls: [],
    totalCount: 0,
    totalDuration: 0,
  };
  public callHistoryLoading: boolean = false;
  public loading: boolean = false;
  public pageNumber: number = 1;
  public pageSize: number = 25;
  public isDescending: boolean = true;
  public orderBy: string = 'dateTimeOfCall';
  public chartData: number[] = [];
  private api: CallsApi;

  constructor() {
    super();
    this.api = new CallsApi();
  }

  public async created() {
    this.callHistoryColumns = [
      {
        prop: 'dateTimeOfCall',
        label: this.$t('calls.dateTimeOfCall'),
        sortable: 'custom',
        translable: false,
      },
      {
        prop: 'phoneNumber',
        label: this.$t('calls.phoneNumber'),
        sortable: 'custom',
        translable: false,
      },
      {
        prop: 'callDuration',
        label: this.$t('calls.callDuration'),
        sortable: 'custom',
        translable: false,
      },
      {
        prop: 'callType',
        label: this.$t('calls.callType'),
        sortable: false,
        translable: true,
      },
      {
        prop: 'callStatus',
        label: this.$t('calls.callStatus'),
        sortable: false,
        translable: true,
      },
      {
        prop: 'wasRecognized',
        label: this.$t('calls.wasRecognized'),
        sortable: false,
        translable: true,
      },
    ];

    this.refreshCallsHistory();
  }

  public async refreshCallsHistory() {
    this.callHistoryLoading = true;
    try {
      this.callHistoryData = await this.api.getCallsHistory(
        this.pageNumber,
        this.pageSize,
        this.isDescending,
        this.orderBy,
      );
      this.chartData = this.callHistoryData.calls.map(c => c.callDurationInSeconds);
    } catch (error) {
      console.error(error);
    }
    this.callHistoryLoading = false;
  }

  public changeCallsHistoryPageSize(val: number) {
    this.pageSize = val;
    this.refreshCallsHistory();
  }

  public setSortCallsHistory(val: any) {
    if (val.order === null) {
      this.orderBy = val.prop;
      this.isDescending = false;
      (this.$refs.callsHistoryTable as Vue & { sort: (prop: string, sort: string) => {}})
      .sort(val.prop, 'ascending');
    } else {
      this.orderBy = val.prop.charAt(0).toUpperCase() + val.prop.slice(1);
      val.order === 'ascending' ? this.isDescending = false : this.isDescending = true;
    }
    this.refreshCallsHistory();
  }

  public formatDateTime(textDate: string) {
    const date = moment(textDate);
    return date.format('DD/MM/YYYY HH:mm');
  }

  public formatDuration(textDate: string) {
    const date = moment(textDate, 'HH:mm:ss');
    return date.format('HH:mm:ss');
  }

  public lastCallDate(callHistoryData: CallHistoryVm) : string {
    if(callHistoryData.calls.length === 0)
    {
      return ""
    }
    const lastCallDate = callHistoryData.calls.reduce((a,b) => 
              (a.dateTimeOfCall > b.dateTimeOfCall ? a : b)).dateTimeOfCall;
              
    const date = moment(lastCallDate).locale(this.$i18n.locale);
    return `${date.fromNow()} (${date.format("YYYY-MM-DD hh:mm")})`;
  }

  public translate(text: string) {
    if (text == null) {
      return '';
    }

    return this.$t('calls.' + text);
  }
}
